<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Test Table Data Loading...
  </div>
  <div v-else class="animated">
    <h3>
      Test Schedules
      <b-button class="text-white float-right ml-1" variant="success">
        <i class="fa fa-check-square" /> Approve All
      </b-button>
    </h3>
    <instrument-instance-schedule-server-table
      :task_id_collection="test_task_id_collection"
      process_type="test"
    />
  </div>
</template>

<script>
import InstrumentInstanceScheduleServerTable from "@/components/lab/instrumentinstanceschedule/InstrumentInstanceScheduleServerTable";
import { getCollection } from "@/shared/fetch-utils";

export default {
  name: "SampleTestTable",
  components: {
    InstrumentInstanceScheduleServerTable
  },
  props: {
    trigger_approval_all: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: true,
      sample_id: this.$route.params.sample_id || null,
      test_task_collection: null,
      test_task_id_collection: null
    };
  },
  async created() {
    this.loading = true;

    this.test_task_collection = await getCollection({
      collection_type: "test_task",
      message: this.$bvToast
    });

    this.test_task_id_collection = this.test_task_collection.models.map(
      ({ id }) => id
    );

    this.loading = false;
  }
};
</script>
